export enum ApplicationRouteNames {
  CANCEL_RESERVATION = 'reservation-cancellation',
  CHANGE_RESERVATION = 'change-reservation',
  MANAGE_YOUR_STAY = 'ManageYourStay',
  CANCEL_CONFIRMATION = 'cancellation-confirmation',
  STAY_PREFERENCES = 'stay-preferences',
  WRITE_REVIEW = 'reviews/:hotelCode/write-a-review',
  SUBMIT_REVIEW = 'reviews/:hotelCode/submit-a-review'
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/common/model/application-route-names.model.ts